// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/list/style/index.less
// module id = 1040
// module chunks = 1